import { SampleSex } from "@app/api2/api";
import React from "react";
import { Dropdown, Icon } from "@/components/bp/bp-ui";
import { IconSizeProp } from "semantic-ui-react/dist/commonjs/elements/Icon/Icon";


interface IGenderSelectorProps {
  name: string;
  value: SampleSex;
  onChange?: (ev, value: SampleSex) => void;
  readOnly?: boolean;
  iconSize?: IconSizeProp;
  showIcon: boolean;
  showLabel: boolean
  // iconOnly?: boolean;
  // labelOnly?: boolean;
}

export const GenderSelectorSelect: React.FunctionComponent<IGenderSelectorProps> = (props) => {
  const t = window.translation;
  const options = [{ type: SampleSex.Female.valueOf(), label: t.brutus.female }, { type: SampleSex.Male.valueOf(), label: t.brutus.male }]

  return props.readOnly ? <>
    {props.value != null && props.showIcon &&
      <Icon size={props.iconSize ?? "large"} name={props.value == SampleSex.Male ? 'man' : 'woman'}></Icon>
    }
    <span>{props.showLabel ? options.find(x => x.type == props.value)?.label : ""}</span>
  </> : <Dropdown
    name={props.name}
    scrolling selection fluid
    onChange={(ev, { value }) => {
      if (props.onChange)
        props.onChange(ev, value as SampleSex);
    }}
    options={[...options.map((type) => { return { key: type.type, value: type.type, text: type.label }; })]}
    value={props.value}>
  </Dropdown>
};

